import View from "../framework/view";
import template from "../../pugc/backup";
import Server, {getPreviewId, setPreviewId} from "../server";
import {WebsiteVersion} from "../bo/website_version";
import {formatTimestamp} from "../misc/dates";
import jQuery from "jquery";

const classname = "backup-view";

const server = Server.instance();

export class BackupView extends View {

    private history: WebsiteVersion[] | undefined;

    constructor() {
        super(classname);
        this.init();
    }

    async init() {
        this.history = await server.websiteHistory();
        this.update(".history");
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {
            previewId: getPreviewId(),
            history: this.history,
            formatTimestamp: formatTimestamp
        };
        const out = this.pug(template, data);
        return out;
    }

    async importShop() {
        const input = this.elt().find("input.shop") as JQuery<HTMLInputElement>;
        const file = input[0].files && input[0].files.length && input[0].files[0];
        if (! file) {
            return;
        }
        const data = await file.text();
        const shop = JSON.parse(data);
        const upload = await server.importShop(shop);
    }

    async importWeb() {
        const input = this.elt().find("input.web") as JQuery<HTMLInputElement>;
        const file = input[0].files && input[0].files.length && input[0].files[0];
        if (! file) {
            return;
        }
        const data = await file.text();
        const web = JSON.parse(data);
        const upload = await server.importWebsite(web);
    }

    preview(id: number | undefined) {
        setPreviewId(id);
        this.update(".history");
    }

    async restore(id: number) {
        await server.websiteRestore(id);
        await this.init();
    }
}


View.on(
    "." + classname,
    "click",
    "button.import-shop",
    function(that: BackupView, event, elt) {
        event.preventDefault();
        that.importShop();
    });

View.on(
    "." + classname,
    "click",
    "button.import-web",
    function(that: BackupView, event, elt) {
        event.preventDefault();
        that.importWeb();
    });

View.on(
    "." + classname,
    "click",
    "button.restore",
    function(that: BackupView, event, elt) {
        event.preventDefault();
        const id = +(jQuery(elt).data("id"));
        that.restore(id);
    });

View.on(
    "." + classname,
    "click",
    "button.preview",
    function(that: BackupView, event, elt) {
        event.preventDefault();
        const id = +(jQuery(elt).data("id"));
        that.preview(id);
    });

View.on(
    "." + classname,
    "click",
    "button.stop-preview",
    function(that: BackupView, event, elt) {
        event.preventDefault();
        const id = +(jQuery(elt).data("id"));
        that.preview(undefined);
    });

